import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dpqa-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.less',
})
export class LoadingSpinnerComponent {}
